module.exports = __webpack_public_path__ + "img/gamemode@2x.8ddfcdb0.png";